import { Button } from 'antd';
import styled from 'styled-components';
import { blueDark02, blueLink } from '../../../styles/colors';

export const SaveButton = styled(Button)`
    height: 32px;
    background: none;
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid ${blueDark02};
    padding: 7px 42px;
    color: ${blueDark02};
    font-family: 'DINNextLTPro';
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    padding-horizontal: 16px;
    margin-bottom: 9px;
    &:hover {
        border: 1px solid ${blueLink};
        color: ${blueLink};
    }
`;

export const TagInput = styled('div')`
    display: flex;
    align-items: end;
    margin-bottom: 20px;
    .ant-input {
        margin-right: 0px;
    }
`;

export const TagsSubTitle = styled('div')`
    color: #000;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 24px;
`;
